// extracted by mini-css-extract-plugin
export default {"container":"Ul-he_3gvHYk6L0p56xo4"};